import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LabelList,
} from 'recharts';

import {
  ReasonBreakdownResponse,
} from '../../../types/Manager/atRiskAssociates.types';

type Props = {
  data: ReasonBreakdownResponse[];
  error?: string | null;
};

type TooltipProps = {
  active?: boolean;
  payload?: any[];
};

const CustomTooltip = ({
  active,
  payload,
}: TooltipProps) => {

  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const item = payload[0].payload;

  return (

    <div
      className="
        rounded-md
        border
        border-slate-300
        bg-white
        px-3
        py-2
        shadow-lg
      "
    >

      <p className="text-[13px] font-semibold text-slate-800">
        {item.reason}
      </p>

      <p className="mt-1 text-[12px] text-red-500">
        Associate :
        <span className="ml-1 font-semibold">
          {item.count}
        </span>
      </p>

    </div>

  );

};

const RiskReasonBreakdownChart = ({
  data,
  error,
}: Props) => {

  if (error) {
    return (
      <div className="flex h-[300px] items-center justify-center rounded-2xl border border-red-200 bg-white p-4">
        <p className="font-medium text-red-600">
          {error}
        </p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="flex h-[300px] items-center justify-center rounded-2xl border border-slate-200 bg-white p-4">
        <p className="text-slate-500">
          No Risk Reason Breakdown data available.
        </p>
      </div>
    );
  }

  return (

        <div className="rounded-2xl border border-slate-200 bg-white p-4 h-[300px]">

      {/* Header */}

      <div className="mb-3 flex items-center gap-2">

        <h3 className="text-[15px] font-semibold text-[#003E7E]">
          Risk Reason Breakdown
        </h3>

        <span className="rounded-full bg-blue-50 px-3 py-1 text-[10px] text-blue-600">
          Flags triggering at-risk status
        </span>

      </div>

      <ResponsiveContainer
        width="100%"
        height={220}
      >

        <BarChart
  data={data}
  layout="vertical"
  margin={{
    top: 10,
    right: 20,
    left: 20,
    bottom: 20,
  }}
>

         <XAxis
  type="number"
  domain={[0, 'dataMax']}
  tickCount={6}
  axisLine={false}
  tickLine={false}
  tick={{ fontSize: 12, fill: '#64748b' }}
  dy={10}
  padding={{ left: 10, right: 10 }}
/>

          <YAxis
            type="category"
            dataKey="reason"
            width={115}
            tick={{
              fontSize: 11,
              fill: '#475569',
            }}
            axisLine={false}
            tickLine={false}
          />

          <Tooltip
            cursor={{
              fill: 'rgba(0,0,0,0.04)',
            }}
            content={<CustomTooltip />}
          />

          <Bar
            dataKey="count"
            fill="#ef5b5b"
            radius={[5, 5, 5, 5]}
            barSize={18}
          >      
          
            <LabelList
              content={({ x, y, width, height, value }) => (
                <text
                  x={(x as number) + (width as number) - 8}
                  y={(y as number) + (height as number) / 2}
                  textAnchor="end"
                  dominantBaseline="middle"
                  fill="#FFFFFF"
                  fontSize={11}
                  fontWeight={700}
                >
                  {value}
                </text>
              )}
            />

          </Bar>

        </BarChart>

      </ResponsiveContainer>

    </div>

  );

};

export default RiskReasonBreakdownChart;